import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export function useGroupingStatusToggle(setIsVisible) {
  const [searchParams, setSearchParams] = useSearchParams();
  const status = searchParams.get("switch") === "true";

  const toggleStatus = useCallback((event) => {
    const nextStatus =
      event?.target?.checked ?? event?.currentTarget?.checked ?? !status;

    if (nextStatus) {
      setIsVisible?.();
    }

    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.set("switch", nextStatus);
    setSearchParams(nextSearchParams);
  }, [searchParams, setIsVisible, setSearchParams, status]);

  return {
    status,
    toggleStatus,
  };
}
